export enum WELLS_TYPE {
  planned = 'PLANNED',
  unplanned = 'UNPLANNED',
}

export type TSwitchButtonItem = {
  key: WELLS_TYPE;
  title: string;
};
